module.exports = __webpack_public_path__ + "static/ip-ikon2-e1815a28c65f2d77c8a8da7a356342bc.png";